import { render, staticRenderFns } from "./MySortControl.vue?vue&type=template&id=64c257b0&"
import script from "./MySortControl.vue?vue&type=script&lang=js&"
export * from "./MySortControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports